import { render, staticRenderFns } from "./secao-02-processo.vue?vue&type=template&id=ee5a167e"
import script from "./secao-02-processo.vue?vue&type=script&lang=js"
export * from "./secao-02-processo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports